export function rgTrxInProcess(state) {
    return state.rgTrx.filter(v => v.status === 1);
}

export function rgTrxPending(state) {
    return state.rgTrx.filter(v => v.status === 0);
}

export function supplierTrxPending(state) {
    return state.rgTrx.filter(v => v.status === 0);
}
